import { inflect } from 'inflection'
import { MAX_FILE_SIZE } from './constants'

export const bytesToMegabyteString = (bytes: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'unit',
    unit: 'megabyte',
    unitDisplay: 'narrow'
  }).format(bytes / 1024 / 1024)
}

export const validatePickedFiles = ({
  files,
  maximumNumberOfFiles,
  maximumNumberOfFilesError
}: {
  files: File[]
  maximumNumberOfFiles: number
  // Overrides the default "at a time" message for callers enforcing a cumulative cap.
  maximumNumberOfFilesError?: string
}): string | undefined => {
  const maxFileSizeErrors = files
    .filter(file => file.size > MAX_FILE_SIZE)
    .map(file => file.name)

  if (files.length > maximumNumberOfFiles) {
    return (
      maximumNumberOfFilesError ??
      `You may upload a maximum of ${maximumNumberOfFiles} ${inflect(
        'file',
        maximumNumberOfFiles
      )} at a time.`
    )
  }

  if (maxFileSizeErrors.length) {
    const errorMessage =
      maxFileSizeErrors.length === 1
        ? `${maxFileSizeErrors[0]} is too large.`
        : 'Multiple files are too large.'

    return `${errorMessage} Maximum ${bytesToMegabyteString(MAX_FILE_SIZE)}`
  }

  return undefined
}
